<template>
  <div>
    <app-header title="">
      <template v-slot:actions>
        <router-link
          :to="{ name: 'project-calculations.create' }"
          class="btn btn-primary mt-2 mt-xl-0"
        >
          <i class="far fa-plus"></i> Project Calculation
        </router-link>
      </template>
    </app-header>

    <div class="container my-5">
      <h2>Project Calculations</h2>

      <project-calculation-list-filters v-model="params" />

      <c-data-list ref="dataList" :items="projectCalculations" @load="loadNextPage">
        <template v-slot:columns>
          <div class="col-12 col-lg-4">
            <p>Name</p>
          </div>
          <div class="col-6 col-lg-2">
            <p>Client</p>
          </div>
          <div class="col-6 col-lg-2">
            <p>Opportunity</p>
          </div>
          <div class="col-6 col-lg-2">
            <p>Total Budget</p>
          </div>
          <div class="col-6 col-lg-2 text-end">
            <p>Last Updated</p>
          </div>
        </template>
        <template v-slot:default="slotProps">
          <router-link
            :to="{
              name: 'project-calculations.edit',
              params: { projectCalculationId: slotProps.item.id },
            }"
          >
            <div class="row">
              <div class="col-12 col-lg-4">
                <p class="text-truncate">
                  <span class="data-label d-lg-none">Name:</span>
                  <strong>{{ slotProps.item.name }}</strong>
                </p>
              </div>
              <div class="col-6 col-lg-2">
                <p class="text-truncate">
                  <span class="data-label d-lg-none">Client:</span>
                  {{ slotProps.item.client ? slotProps.item.client.company : '-' }}
                </p>
              </div>
              <div class="col-6 col-lg-2">
                <p class="text-truncate">
                  <span class="data-label d-lg-none">Opportunity:</span>
                  {{ slotProps.item.opportunity ? slotProps.item.opportunity.name : '-' }}
                </p>
              </div>
              <div class="col-6 col-lg-2">
                <p>
                  <span class="data-label d-lg-none">Total Budget:</span>
                  ${{ slotProps.item.total_budget | currency }}
                </p>
              </div>
              <div class="col-6 col-lg-2 text-end">
                <p>
                  <span class="data-label d-lg-none">Updated:</span>
                  {{ slotProps.item.updated_at | moment("DD/MM/YYYY HH:mm") }}
                </p>
              </div>
            </div>
          </router-link>
        </template>
      </c-data-list>
    </div>
  </div>
</template>

<script>
import { isEqual } from 'lodash'
import { helperMethods, helperComputed } from 'vx/modules/project-calculations'
import ProjectCalculationListFilters from './ProjectCalculationListFilters.vue'

export default {
  components: { ProjectCalculationListFilters },

  data() {
    return {
      params: {},
    }
  },

  mounted() {
    this.getProjectCalculations({ params: this.params, fresh: true })

    this.$watch('params', async (params, oldParams) => {
      if (isEqual(params, oldParams)) return
      await this.getProjectCalculations({ params, fresh: true })
    })
  },

  computed: {
    ...helperComputed,
  },

  methods: {
    ...helperMethods,

    async loadNextPage(done) {
      try {
        await this.getProjectCalculationsForNextPage({ params: this.params })
        done()
      } catch (error) {
        done(true)
      }
    },
  },
}
</script>
